<template>
    <!-- Start Main Content -->
    <div
        class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">

        <!-- Add notice form -->
        <div class="card p-4 lg:p-6">
            <h6 class="card-title">Add Product</h6>
            <form>
                <div class="grid grid-cols-12 gap-x-4 gap-y-5 mt-7 pt-0.5" v-on:keyup.enter="nextFocus">
                    <div class="col-span-full  lg:col-span-4 leading-none">
                        <label class="form-label">Type *</label>
                        <select class="form-input" v-model="product.cat">
                            <option DISABLED value="0">SELECT CATEGORY</option>
                            <option v-for="(item, index)  in catList" :value="item.id">{{ item.name }}</option>
                        </select>
                    </div>
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Barcode *</label>
                        <input type="number" id="barcode" v-model="product.barcode" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">HSN Code *</label>
                        <input type="number" v-model="product.hsn" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-12 leading-none">
                        <label for="" class="form-label">Product Name *</label>
                        <input type="text" v-model="product.name" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-12 leading-none">
                        <label for="" class="form-label">Product Description *</label>
                        <input type="text" v-model="product.descr" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">Unit *</label>
                        <input type="text" v-model="product.unit" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">GST rate *</label>
                        <input type="number" v-model="product.gst" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">MRP *</label>
                        <input type="number" v-model="product.mrp" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">Purchase rate *</label>
                        <input type="number" v-model="product.prate" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">Sale rate *</label>
                        <input type="number" v-model="product.salerate" placeholder="Type Here" class="form-input"
                            required autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">Set Rate *</label>
                        <input type="number" v-model="product.set_rate" placeholder="Type Here" class="form-input"
                            required autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">Set Quantity *</label>
                        <input type="number" v-model="product.set_qty" placeholder="Type Here" class="form-input"
                            required autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">Opening Stock *</label>
                        <input type="number" v-model="product.op_qty" placeholder="Type Here" class="form-input"
                            required autocomplete="off">
                    </div>
                </div>
            </form>
            <button @click="save" id="saveBtn" class="btn b-solid btn-primary-solid px-5 cursor-pointer mt-6">
                Add Product
            </button>

        </div>
    </div>



</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
    name: 'AddProduct',
    components: {

    },
    mounted() {
        this.getBasics();
        $(".form-input").on('keyup')
    },
    data() {
        return {
            isAdd: 0,
            isEdit: 0,
            isDelete: 0,
            deleteId: 0,
            catList: [],
            product: { name: '', cat: '0', barcode: '', hsn: '', descr: '', gst: '5', unit: '', mrp: '0', prate: '0', salerate: '0', set_rate: '0', set_qty: '0', op_qty: 0 },
            employees: { empname: '', emprole: '0', isMainAdmin: 0 },
        }
    },
    methods: {
        async getBasics() {
            var self = this;
            axios.post('getProdCats').then(function (response) {
                self.catList = response.data.cats;
                self.employees = response.data.userDetails;
            });
        },
        nextFocus(e) {
            const inputs = Array.from(e.target.form.querySelectorAll('input'));
            const index = inputs.indexOf(e.target);

            if (index < inputs.length) {
                try {
                    inputs[index + 1].focus();
                    inputs[index + 1].select();
                } catch (error) {
                    $("#saveBtn").focus();
                }
            }
        },
        save() {
            var self = this;
            if (self.product.name == '') 
                self.$swal("Product Name is Required");
            else if (self.product.salerate == '') 
                self.$swal("Salerate is Required"); 
            else {
                self.$swal({
                    title: "Do You Want To Save?",
                    text: "Are you sure? ",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes"
                }).then((result) => { // <--
                    if (result.value) { // <-- if confirmed
                        axios.post('addProduct', this.product)
                            .then(response => {
                                var msg = response.data.msg;
                                var isSuccess = response.data.status;
                                self.catList = response.data.cats;
                                self.employees = response.data.userDetails;
                                self.cat = { name: '', status: 'Active' };
                                if (isSuccess == 1) {
                                    self.product = { name: '', cat: '0', barcode: '', hsn: '', descr: '', gst: '5', unit: '', mrp: '0', prate: '0', salerate: '0', set_rate: '0', set_qty: '0', op_qty: '0' };
                                    $("#barcode").focus();
                                }


                                self.$swal(msg);

                            })
                            .catch(error => {
                                console.log('Error on Authentication: ' + error);
                            });
                    }
                });
            }

        }
    }
}
</script>
